// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2rsIK","title":"ClientReferral_title__33nLp","itemText":"ClientReferral_itemText__3KH6y"};